/* Filters in a drawer (Seth, 2026-10-02): open and close, the count of filters in use on the tab, Esc, focus.
   Since 2026-10-11 (Seth: filters easier to find) two buttons open it: the tab on the left edge and the Filters button
   above the doors (snippets/mad-filter-button.liquid). Both show the count; focus goes back to the one that opened it;
   Clarity hears which one was used (filters_open_desktop_tab, filters_open_desktop_button).
   Second check of 2026-10-11: the fixed tab counts as on screen (offsetParent is always null for a fixed element, so
   focus used to go to the button above the doors, often off screen); the number counts the chips the drawer shows (one
   per Width or Height range, one per price range, one per ticked value), as the phone button does in
   snippets/facets.liquid, so Single, Glass and Carved read 3, not 1. */
(function () {
  'use strict';
  if (window.__madFilterDrawer) return;
  window.__madFilterDrawer = true;
  var root = document.documentElement;
  function panel() { return document.getElementById('main-collection-filters'); }
  function openers() { return document.querySelectorAll('[data-mad-fd-open]'); }
  function each(fn) { Array.prototype.forEach.call(openers(), fn); }
  function seen(el) {
    if (!el || !el.isConnected || !el.getClientRects().length) return false;
    return window.getComputedStyle(el).visibility !== 'hidden';
  }
  function isOpen() { return root.classList.contains('mad-fd-open'); }
  /* snippets/mad-clarity.liquid holds markers until Clarity has started (window.madClarityEvent) */
  function tag(name) { try { if (typeof window.madClarityEvent === 'function') window.madClarityEvent(name); else if (typeof window.clarity === 'function') window.clarity('event', name); } catch (e) { /* never block */ } }
  var opener = null;
  function open(from) {
    var p = panel(); if (!p) return;
    opener = from || null;
    root.classList.add('mad-fd-open');
    each(function (t) { t.setAttribute('aria-expanded', 'true'); });
    p.setAttribute('aria-hidden', 'false');
    var c = p.querySelector('[data-mad-fd-close]');
    setTimeout(function () { if (c) c.focus(); }, 60);
    tag('filters_open_' + ((from && from.getAttribute('data-mad-fd-where')) || 'desktop_tab'));
  }
  function close() {
    if (!isOpen()) return;
    root.classList.remove('mad-fd-open');
    each(function (t) { t.setAttribute('aria-expanded', 'false'); });
    var back = seen(opener) ? opener : Array.prototype.filter.call(openers(), seen)[0];
    if (back) { try { back.focus({ preventScroll: true }); } catch (e) { back.focus(); } }
  }
  /* how many filters are in use: the chips in the drawer (snippets/facets.liquid draws one per Width or Height range,
     one per price range and one per ticked value); without chips on the page, the address read the same way */
  function count() {
    var p = panel();
    var chips = p ? p.querySelectorAll('.active-facets-desktop a.active-facets__button') : [];
    var n = chips.length;
    if (!p || !p.querySelector('.active-facets-desktop')) {
      var keys = {};
      n = 0;
      new URLSearchParams(window.location.search).forEach(function (v, k) {
        if (k.indexOf('filter.') !== 0 || String(v).trim() === '') return;
        if (/^filter\.v\.(option\.(width|height)|price\.(gte|lte))$/.test(k)) keys[k.replace(/\.(gte|lte)$/, '')] = true;
        else n++;
      });
      n += Object.keys(keys).length;
    }
    each(function (t) {
      var el = t.querySelector('[data-mad-fd-count]');
      if (el) {
        /* the tab reads "Filters · 2"; the button above the doors shows the number in a small round badge */
        el.textContent = n ? (el.getAttribute('data-mad-fd-count') === 'badge' ? String(n) : '\u00b7 ' + n) : '';
        el.hidden = !n;
      }
      var label = t.getAttribute('data-mad-fd-label') || 'Filters';
      t.setAttribute('aria-label', n ? label + ', ' + n + ' in use' : label);
    });
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-mad-fd-open]');
    if (o) { e.preventDefault(); isOpen() ? close() : open(o); return; }
    if (e.target.closest('[data-mad-fd-close]')) { e.preventDefault(); close(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && isOpen()) close(); });
  /* the theme's filters reload the doors and change the address; keep the count current */
  function watch() {
    var grid = document.getElementById('ProductGridContainer');
    if (grid && window.MutationObserver) new MutationObserver(function () { count(); }).observe(grid, { childList: true });
    /* the chips are redrawn on their own (assets/facets.js renderActiveFacets), sometimes after the doors */
    var p = panel(), chips = p && p.querySelector('.active-facets-desktop');
    if (chips && window.MutationObserver) new MutationObserver(function () { count(); }).observe(chips, { childList: true, subtree: true });
    count();
  }
  window.addEventListener('popstate', count);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
  /* allow the slide only once the page has drawn, two frames after load */
  function ready() { requestAnimationFrame(function () { requestAnimationFrame(function () { root.classList.add('mad-fd-ready'); }); }); }
  /* 2026-10-08 launch review: turning a phone sideways crosses 750 px and swapped the panel with a visible slide;
     drop the transitions for that moment and bring them back two frames later. */
  if (window.matchMedia) {
    var mq = window.matchMedia('(min-width: 750px)');
    var onCross = function () { root.classList.remove('mad-fd-ready'); ready(); };
    if (mq.addEventListener) mq.addEventListener('change', onCross); else if (mq.addListener) mq.addListener(onCross);
  }
  if (document.readyState === 'complete') ready(); else window.addEventListener('load', ready);
})();
